"use client";

import { useState } from "react";
import type { Faq } from "./content";

// Local FAQ accordion for /100 (kept local rather than refactoring the shared
// BatheFaqs, whose content is a hard-coded module const — this stays additive and
// conflict-free). One panel open at a time.
export function MembershipFaqs({ items }: { items: Faq[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="max-w-[900px] border-t border-rule">
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-rule">
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-5 py-6 text-left"
            >
              <span style={{ fontFamily: "var(--font-display)" }} className="text-[clamp(17px,2vw,21px)] font-light text-ink">
                {f.q}
              </span>
              <span
                aria-hidden
                className="shrink-0 text-[22px] leading-none text-tussock transition-transform duration-300"
                style={{ transform: isOpen ? "rotate(45deg)" : "none" }}
              >
                +
              </span>
            </button>
            <div
              className="grid transition-[grid-template-rows] duration-500 ease-out"
              style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
            >
              <div className="overflow-hidden">
                <div className="max-w-[68ch] pb-7 text-[15px] font-light leading-relaxed text-mocha">
                  <p className="mb-0">{f.a}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
